/* Sharrow Newsroom scripts (converted from Squarespace). */
(function () {
  const BLOG_SLUG = "/news";
  const PAGE_SIZE = 24;
  const MAX_PAGES = 20;

  let allPosts = [];
  let filteredPosts = [];
  let visibleCount = PAGE_SIZE;

  const root = document.getElementById("sharrowNewsroomFeed");
  if (!root) return;

  const featured = document.getElementById("snFeatured");
  const grid = document.getElementById("snGrid");
  const status = document.getElementById("snStatus");
  const count = document.getElementById("snCount");
  const search = document.getElementById("snSearch");
  const loadMore = document.getElementById("snLoadMore");
  const overlay = document.getElementById("snOverlay");
  const panelContent = document.getElementById("snPanelContent");
  const closeBtn = document.getElementById("snClose");
  const overlayBg = overlay ? overlay.querySelector(".sn-overlay-bg") : null;

  function stripHtml(html) {
    const div = document.createElement("div");
    div.innerHTML = html || "";
    return (div.textContent || div.innerText || "").replace(/\s+/g, " ").trim();
  }

  function cleanText(value, limit) {
    let text = stripHtml(value || "");

    // Squarespace can sometimes expose page CSS or block code in excerpts/titles.
    // Remove common leaked CSS/code fragments before rendering card text.
    text = text
      .replace(/#block-[^{}]+\{[^}]*\}/gi, " ")
      .replace(/#[a-z0-9_-]+\s*\{[^}]*\}/gi, " ")
      .replace(/@media[^{}]+\{[^}]*\}/gi, " ")
      .replace(/--[a-z0-9-]+\s*:[^;]+;?/gi, " ")
      .replace(/\b(?:font|margin|padding|border|background|color|display|position|width|height|line-height|letter-spacing|text-align|transform|transition|opacity|overflow|z-index)\s*:[^;]+;?/gi, " ")
      .replace(/\{[^}]*\}/g, " ")
      .replace(/<\/?(?:style|script)[^>]*>/gi, " ")
      .replace(/\s+/g, " ")
      .trim();

    if (limit && text.length > limit) text = text.slice(0, limit).replace(/\s+\S*$/, "");
    return text;
  }

  function esc(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function formatDate(value) {
    if (!value) return "";
    const d = new Date(value);
    if (isNaN(d.getTime())) return value;
    return d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
  }

  function absolutize(url) {
    if (!url) return "";
    try { return new URL(url, window.location.origin).href; } catch (e) { return url; }
  }

  function getImage(item) {
    const candidates = [
      item.assetUrl, item.thumbnailUrl, item.imageUrl, item.featuredImageUrl,
      item.asset && item.asset.url,
      item.image && item.image.url,
      item.media && item.media.url
    ];
    return absolutize(candidates.find(Boolean) || "");
  }

  function getTags(item) {
    const cats = Array.isArray(item.categories) ? item.categories : [];
    const tags = Array.isArray(item.tags) ? item.tags : [];
    return [...new Set([...cats, ...tags].map(t => typeof t === "string" ? t : t && t.name).filter(Boolean))];
  }

  function getSubheading(item) {
    const subheading = item.excerpt || item.description || item.seoDescription || item.summary || item.customExcerpt || "";
    return cleanText(subheading, 190);
  }

  function normalize(item) {
    const body = item.body || item.fullContent || item.excerpt || item.description || "";
    const plain = cleanText(body);
    const tags = getTags(item);
    const subheading = getSubheading(item) || cleanText(plain, 190);
    const title = cleanText(item.title || "Untitled", 130) || "Untitled";
    const url = absolutize(item.fullUrl || item.sourceUrl || item.url || item.publicUrl || "");
    return {
      title: title,
      date: item.publishOn || item.addedOn || item.updatedOn || item.createdOn || "",
      image: getImage(item),
      body: body,
      plain: plain,
      subheading: subheading,
      tags: tags,
      url: url,
      searchText: [title, subheading, plain, tags.join(" ")].join(" ").toLowerCase()
    };
  }

  async function fetchJson(url) {
    const el = document.getElementById("sharrow-news-data");
    return el ? JSON.parse(el.textContent) : { items: [] };
  }

  async function fetchText(url) {
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) throw new Error("Fetch failed: " + url);
    return response.text();
  }

  function nextJsonUrl(data) {
    let nextUrl = null;
    if (data.pagination && data.pagination.nextPageUrl) nextUrl = data.pagination.nextPageUrl;
    else if (data.nextPageUrl) nextUrl = data.nextPageUrl;
    else if (data.collection && data.collection.nextPageUrl) nextUrl = data.collection.nextPageUrl;
    else if (data.pagination && data.pagination.nextPage) nextUrl = data.pagination.nextPage;
    if (nextUrl && nextUrl.indexOf("format=json") === -1) nextUrl += (nextUrl.indexOf("?") > -1 ? "&" : "?") + "format=json";
    return nextUrl;
  }

  async function fetchPostsFromJson() {
    let items = [];
    let seen = {};
    let nextUrl = BLOG_SLUG + "?format=json";
    let safety = 0;
    while (nextUrl && safety < MAX_PAGES) {
      safety++;
      const data = await fetchJson(nextUrl);
      const batch = Array.isArray(data.items) ? data.items : [];
      batch.forEach(item => {
        const key = item.id || item.urlId || item.fullUrl || item.url || item.title;
        if (key && !seen[key]) { seen[key] = true; items.push(item); }
      });
      nextUrl = nextJsonUrl(data);
    }
    return items.map(normalize);
  }

  function parseBlogList(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    const links = Array.from(doc.querySelectorAll('a[href*="/news/"]'));
    const seen = new Set();
    const posts = [];
    links.forEach(a => {
      const href = a.getAttribute("href") || "";
      if (!href || href.indexOf("/news/") === -1 || seen.has(href)) return;
      const article = a.closest("article, .blog-item, .summary-item, .entry, section, div") || a.parentElement;
      const title = stripHtml(a.textContent).replace(/^Read More$/i, "").trim();
      if (!title || title.length < 8) return;
      const text = article ? stripHtml(article.innerHTML) : title;
      const img = article ? article.querySelector("img") : null;
      const image = img ? (img.getAttribute("data-src") || img.getAttribute("src") || "") : "";
      seen.add(href);
      posts.push({
        title: title,
        date: "",
        image: absolutize(image),
        body: '<p>' + esc(text) + '</p><p><a href="' + esc(absolutize(href)) + '">Open full story</a></p>',
        plain: text,
        subheading: text.replace(title, "").slice(0, 190),
        tags: [],
        url: absolutize(href),
        searchText: (title + " " + text).toLowerCase()
      });
    });
    return posts;
  }

  async function fetchPostsFromPageFallback() {
    let posts = [];
    let url = BLOG_SLUG;
    let safety = 0;
    const seenPages = new Set();
    while (url && safety < MAX_PAGES && !seenPages.has(url)) {
      safety++;
      seenPages.add(url);
      const html = await fetchText(url);
      posts = posts.concat(parseBlogList(html));
      const doc = new DOMParser().parseFromString(html, "text/html");
      const older = Array.from(doc.querySelectorAll("a")).find(a => /older posts/i.test(a.textContent || ""));
      url = older ? absolutize(older.getAttribute("href")) : "";
    }
    const seen = new Set();
    return posts.filter(post => {
      const key = post.url || post.title;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  async function fetchAllPosts() {
    status.style.display = "block";
    status.textContent = "Loading newsroom...";
    try {
      allPosts = await fetchPostsFromJson();
    } catch (e) {
      console.warn("Squarespace JSON failed. Falling back to page parsing.", e);
      allPosts = await fetchPostsFromPageFallback();
    }
    allPosts.sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));
    applySearch();
  }

  function applySearch() {
    const q = (search.value || "").toLowerCase().trim();
    filteredPosts = allPosts.filter(post => !q || post.searchText.includes(q));
    visibleCount = PAGE_SIZE;
    render();
  }

  function readDataAttributes(post) {
    return `data-title="${encodeURIComponent(post.title)}" data-body="${encodeURIComponent(post.body)}" data-subheading="${encodeURIComponent(post.subheading || "")}" data-url="${encodeURIComponent(post.url || "")}"`;
  }

  function cardButton(post) {
    return `<button class="sn-btn sn-btn-primary sn-read" type="button" ${readDataAttributes(post)}>Read Story</button>`;
  }

  function shareBlock(title, url) {
    const shareUrl = url || window.location.href;
    const encodedUrl = encodeURIComponent(shareUrl);
    const encodedTitle = encodeURIComponent(title || "Sharrow Marine Newsroom");
    return `
      <div class="sn-share-wrap">
        <div class="sn-share-label">Share this story</div>
        <div class="sn-share-actions">
          <button class="sn-share-btn sn-copy-link" type="button" data-share-url="${esc(shareUrl)}">Copy Link</button>
          <a class="sn-share-btn" href="mailto:?subject=${encodedTitle}&body=${encodedUrl}">Email</a>
          <a class="sn-share-btn" target="_blank" rel="noopener" href="https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}">LinkedIn</a>
          <a class="sn-share-btn" target="_blank" rel="noopener" href="https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}">Facebook</a>
          <a class="sn-share-btn" target="_blank" rel="noopener" href="https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}">X</a>
        </div>
      </div>`;
  }

  function renderFeatured(posts) {
    featured.innerHTML = "";
    posts.slice(0, 2).forEach((post, index) => {
      const card = document.createElement("article");
      card.className = "sn-feature-card sn-feature-read";
      card.setAttribute("data-title", encodeURIComponent(post.title));
      card.setAttribute("data-body", encodeURIComponent(post.body));
      card.setAttribute("data-subheading", encodeURIComponent(post.subheading || ""));
      card.setAttribute("data-url", encodeURIComponent(post.url || ""));
      card.innerHTML = `
        ${post.image ? `<img loading="lazy" src="${esc(post.image)}" alt="${esc(post.title)}">` : ""}
        <div class="sn-feature-content">
          <div class="sn-label">${index === 0 ? "Latest Story" : "Featured Update"}</div>
          <h2 class="sn-feature-title">${esc(post.title)}</h2>
          ${post.subheading ? `<div class="sn-feature-sub">${esc(post.subheading)}${post.subheading.length >= 190 ? "..." : ""}</div>` : ""}
        </div>`;
      featured.appendChild(card);
    });
  }

  function renderGrid(posts) {
    grid.innerHTML = "";
    posts.forEach(post => {
      const card = document.createElement("article");
      card.className = "sn-card";
      card.innerHTML = `
        ${post.image ? `<img class="sn-img" loading="lazy" src="${esc(post.image)}" alt="${esc(post.title)}">` : `<div class="sn-img"></div>`}
        <div class="sn-body">
          <div class="sn-date">${formatDate(post.date)}</div>
          <h2 class="sn-title">${esc(post.title)}</h2>
          ${post.subheading ? `<div class="sn-highlight">“${esc(post.subheading)}${post.subheading.length >= 190 ? "..." : ""}”</div>` : ""}
          <div class="sn-card-actions">${cardButton(post)}</div>
        </div>`;
      grid.appendChild(card);
    });
  }

  function render() {
    grid.innerHTML = "";
    featured.innerHTML = "";
    if (!allPosts.length) {
      status.style.display = "block";
      status.innerHTML = 'No stories yet. Add articles to the News blog in Shopify (Content → Blog posts).';
      count.textContent = "0 stories";
      loadMore.style.display = "none";
      return;
    }
    if (!filteredPosts.length) {
      status.style.display = "block";
      status.textContent = "No matching stories found.";
      count.textContent = allPosts.length + " stories loaded";
      loadMore.style.display = "none";
      return;
    }
    status.style.display = "none";
    const q = (search.value || "").toLowerCase().trim();
    if (!q) {
      renderFeatured(filteredPosts.slice(0, 2));
      renderGrid(filteredPosts.slice(2, visibleCount));
    } else {
      renderGrid(filteredPosts.slice(0, visibleCount));
    }
    count.textContent = filteredPosts.length + " stories loaded";
    loadMore.style.display = filteredPosts.length > visibleCount ? "inline-flex" : "none";
  }

  function openOverlay(title, body, subheading, url) {
    panelContent.innerHTML = `
      <h2 class="sn-panel-title">${esc(title)}</h2>
      ${subheading ? `<p class="sn-panel-sub">${esc(subheading)}</p>` : ""}
      ${shareBlock(title, url)}
      <div class="sn-panel-body">${body}</div>
      <div class="sn-card-actions" style="margin-top:34px;">
        ${url ? `<a class="sn-btn sn-btn-primary" href="${esc(url)}">Open Original Story</a>` : ""}
        <a class="sn-btn sn-btn-primary" href="tel:13136315670">Call Now</a>
        <a class="sn-btn" href="${(window.SHARROW_LINKS||{}).consultation_url}">Book a Consultation</a>
      </div>`;
    overlay.classList.add("open");
    overlay.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeOverlay() {
    overlay.classList.remove("open");
    overlay.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  document.addEventListener("click", function(e) {
    const target = e.target.closest(".sn-read, .sn-feature-read");
    if (!target) return;
    openOverlay(
      decodeURIComponent(target.dataset.title || ""),
      decodeURIComponent(target.dataset.body || ""),
      decodeURIComponent(target.dataset.subheading || ""),
      decodeURIComponent(target.dataset.url || "")
    );
  });

  document.addEventListener("click", async function(e) {
    const copyBtn = e.target.closest(".sn-copy-link");
    if (!copyBtn) return;
    const shareUrl = copyBtn.dataset.shareUrl || window.location.href;
    try {
      await navigator.clipboard.writeText(shareUrl);
      copyBtn.textContent = "Copied";
      copyBtn.classList.add("sn-copied");
      setTimeout(function() { copyBtn.textContent = "Copy Link"; copyBtn.classList.remove("sn-copied"); }, 1600);
    } catch (err) {
      const temp = document.createElement("input");
      temp.value = shareUrl;
      document.body.appendChild(temp);
      temp.select();
      document.execCommand("copy");
      document.body.removeChild(temp);
      copyBtn.textContent = "Copied";
      copyBtn.classList.add("sn-copied");
      setTimeout(function() { copyBtn.textContent = "Copy Link"; copyBtn.classList.remove("sn-copied"); }, 1600);
    }
  });

  search.addEventListener("input", applySearch);
  loadMore.addEventListener("click", function() { visibleCount += PAGE_SIZE; render(); });
  closeBtn.addEventListener("click", closeOverlay);
  overlayBg.addEventListener("click", closeOverlay);
  document.addEventListener("keydown", function(e) { if (e.key === "Escape") closeOverlay(); });

  fetchAllPosts().catch(function(error) {
    console.error(error);
    status.style.display = "block";
    status.innerHTML = 'The newsroom stories could not load.';
    count.textContent = "Error loading stories";
  });
})();
